import apiClient from './apiClient';

export interface WorkRequest {
  id: number;
  employee_id: number;
  employee_name: string | null;
  employee_email: string | null;
  employee_department: string | null;
  message: string | null;
  status: 'pending' | 'resolved' | 'cancelled';
  resolved_by: number | null;
  resolver_name: string | null;
  resolved_at: string | null;
  resolved_project_id: number | null;
  resolved_project_name: string | null;
  created_at: string;
}

const workRequestsApi = {
  createWorkRequest: async (message?: string): Promise<{ message: string; work_request: WorkRequest }> => {
    return apiClient.post('/work-requests', { message });
  },

  getMyRequests: async (): Promise<WorkRequest[]> => {
    return apiClient.get('/work-requests/my-requests');
  },

  getPendingRequests: async (status: string = 'pending'): Promise<WorkRequest[]> => {
    const query = status ? `?status=${encodeURIComponent(status)}` : '';
    return apiClient.get(`/work-requests${query}`);
  },

  resolveWorkRequest: async (id: number, projectId: number): Promise<{ message: string; work_request: WorkRequest }> => {
    return apiClient.put(`/work-requests/${id}/resolve`, { project_id: projectId });
  },

  cancelWorkRequest: async (id: number): Promise<{ message: string; work_request: WorkRequest }> => {
    return apiClient.put(`/work-requests/${id}/cancel`);
  },

  getEmployeeAssignments: async (workRequestId: number): Promise<{
    assigned_project_ids: number[];
    projects: Array<{ id: number; name: string; project_type: string; client_name: string }>;
  }> => {
    return apiClient.get(`/work-requests/${workRequestId}/employee-assignments`);
  },
};

export default workRequestsApi;
